import { render, staticRenderFns } from "./my-gift.vue?vue&type=template&id=f5aa213a&scoped=true&"
import script from "./my-gift.vue?vue&type=script&lang=js&"
export * from "./my-gift.vue?vue&type=script&lang=js&"
import style0 from "./my-gift.vue?vue&type=style&index=0&id=f5aa213a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5aa213a",
  null
  
)

export default component.exports